import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// Global back control. Lives inside the navbar row (left edge) rather than
// floating beneath it, where it used to sit on top of every page's header.
// Icon-only on phones; labelled on wider screens. Hidden on entry pages where
// "back" has no meaning.
const HIDE_ON = ['/', '/login', '/signup', '/auth/callback', '/complete-profile'];

const BackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  if (HIDE_ON.includes(location.pathname)) return null;

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <button
      type="button"
      onClick={handleBack}
      className="inline-flex items-center justify-center gap-1.5 w-11 h-11 -ml-2 md:ml-0 md:w-auto md:h-auto md:px-3 md:py-2 rounded-lg text-sm font-medium text-gray-700 hover:text-stanford-red hover:bg-gray-100 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-stanford-red"
      aria-label="Go back to the previous page"
    >
      <svg className="w-5 h-5 md:w-4 md:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
      </svg>
      <span className="hidden md:inline">Back</span>
    </button>
  );
};

export default BackButton;
